import { L10N } from '../Rates.l10n';

export const getLabelTaxes = (taxesType) => L10N.LABEL_TAXES_FEES[taxesType];
